// extracted by mini-css-extract-plugin
module.exports = {"emptyLabel":"fieldset_emptyLabel__2s4es","fieldsetTitle":"fieldset_fieldsetTitle__3-O3K"};